// src/helpers/preferencesHelpers.js
import { debug } from './debug';

/**
 * Generic helpers for managing user preferences in localStorage.
 * Preferences are stored as JSON and can be any serializable value.
 * Keys are prefixed with user ID for per-user storage.
 */

// Get a preference value from localStorage, with a default fallback
export function getPreference(userId, key, defaultValue) {
  const fullKey = userId ? `${key}_${userId}` : key;
  try {
    const item = localStorage.getItem(fullKey);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    debug(`Failed to parse preference ${fullKey}:`, { type: 'warn' }, error);
    return defaultValue;
  }
}

// Set a preference value in localStorage
export function setPreference(userId, key, value) {
  const fullKey = userId ? `${key}_${userId}` : key;
  try {
    localStorage.setItem(fullKey, JSON.stringify(value));
  } catch (error) {
    debug(`Failed to save preference ${fullKey}:`, { type: 'warn' }, error);
  }
}

// Clear a specific preference
export function clearPreference(userId, key) {
  const fullKey = userId ? `${key}_${userId}` : key;
  localStorage.removeItem(fullKey);
}

// Clear all preferences for a user (or global if no userId)
export function clearAllPreferences(userId) {
  const prefix = userId ? `_${userId}` : '';
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.endsWith(prefix)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
}